import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

import FeatureCarousel from '../components/FeatureCarousel';
import SmartRecipeSearch from '../assets/SmartRecipeSearch.jpg';
import PersonalizedFeed from '../assets/PersonalizedFeed.jpg';
import CommunityDriven from '../assets/CommunityDriven.jpg';
import NutritionalInsights from '../assets/NutritionalInsights.jpg';
const Home = () => {
  const { isAuthenticated } = useAuth();

  const features = [
    {
      image: SmartRecipeSearch,
      title: "Smart Recipe Search",
      description: "Find recipes by ingredients, dietary preferences, or nutritional goals"
    },
    {
      image: PersonalizedFeed,
      title: "Personalized Feed",
      description: "Get recipe recommendations tailored to your taste and health goals"
    },
    {
      image: CommunityDriven,
      title: "Community Driven",
      description: "Like, comment, and share recipes with fellow food enthusiasts"
    },
    {
      image: NutritionalInsights,
      title: "Nutritional Insights",
      description: "Every recipe comes with detailed nutritional information"
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <h1>Nutri<span style={{ color: 'var(--accent)' }}>Lens</span></h1>
            <p className="tagline">
              Discover, share, and enjoy recipes that nourish your body and soul. Connect with a community of food lovers while tracking your nutritional journey.
            </p>
            <div className="cta">
              {!isAuthenticated ? (
                <>
                  <Link to="/login" className="btn btn-accent">Get Started</Link>
                  <Link to="/feed" className="btn btn-outline">Explore Recipes</Link>
                </>
              ) : (
                <Link to="/feed" className="btn btn-accent">View Your Feed</Link>
              )}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section">
        <div className="container">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h2>Why Choose NutriLens?</h2>
            <p className="sub">We combine the joy of cooking with the science of nutrition to help you make informed food choices</p>
          </motion.div>

          <div className="mt-16">
            <FeatureCarousel slides={features} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;